import { useApplicationByEdition } from "./application-by-edition.hook";
import { useCurrentUserProfile } from "./current-user-profile.hook";
import { useEditionById } from "./edition-by-id.hook";

export const useCurrentEnrollment = (editionId: string) => {
  const { data: userProfile } = useCurrentUserProfile();

  const { data: edition, isLoading: isEditionLoading } = useEditionById({
    companyId: userProfile?.companyId || "",
    editionId,
  });

  const enrollmentOpen =
    !!edition && ["IN_PROGRESS", "TO_PUBLISH"].includes(edition.status || "");

  const { data: currentApplication, isLoading: currentApplicationIsLoading } =
    useApplicationByEdition({
      companyId: userProfile?.companyId || "",
      editionId: edition?.id || "",
    });

  // If there is an application for the current edition, the user is already enrolled
  const isAlreadyEnrolled = currentApplication?.status !== "NOT_ENROLLED";

  const canEnroll = enrollmentOpen && !isAlreadyEnrolled;

  // Find the milestone for the enrollment period
  const enrollmentlMilestone =
    edition?.milestones.find(
      (milestone) => milestone.description === "Inscripciones",
    ) || null;

  return {
    enrollmentOpen,
    isAlreadyEnrolled,
    canEnroll,
    currentApplication,
    currentApplicationIsLoading,
    enrollmentlMilestone,
    currentEdition: edition,
    currentEditionIsLoading: isEditionLoading,
    edition,
    isEditionLoading,
  };
};
